export default "__VITE_ASSET__XSISRvkX__"